import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-un-auth-page',
  templateUrl: './un-auth-page.component.html',
  styleUrls: ['./un-auth-page.component.css']
})
export class UnAuthPageComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit() {
  }
backNavigate(){
  this.location.back();
}
}
